import gql from 'graphql-tag';

export const GET_TENANT_INFO = gql`
  query getTenantInfo {
    getTenantInfo {
      id
      name
      logo_url
      custom_css
      partner_type_id
      gtm_id
      title
      circle_image_url
      linkedin_id
      auth0_app_id
      chargebee_site
      linkedin_link
      twitter_link
      facebook_link
      instagram_link
    }
  }
`;
